import { FC } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { ArrowRight } from 'lucide-react';

import { Button } from '@new/common/ui/Button/Button';

export const GoToCourseBuilderCard: FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-start justify-between gap-4 rounded-[9px] border border-(--primary-O400) bg-(--primary-O200) p-6 sm:flex-row sm:items-center">
      <div className="flex flex-col gap-1">
        <h3 className="m-0! [font-size:var(--fs-p3)]! font-bold text-(--neutral-black-NB1000)!">
          Ready to build your degree plan?
        </h3>
        <p className="m-0! [font-size:var(--fs-p4)]! text-(--neutral-black-NB700)!">
          Your transfer credits are in. Head over to the Course Builder to see your personalized
          plan and choose the courses that fit your goals. Whenever your transcripts are evaluated
          or updated, you can regenerate the plan to reflect your latest credits.
        </p>
      </div>
      <Button
        variant="primary"
        className="shrink-0"
        rightIcon={<ArrowRight className="size-4" />}
        text="Go to Course Builder"
        onClick={() => navigate({ to: '/course-builder' })}
      />
    </div>
  );
};
